import React from 'react';
import { Filter,
         Pagination,
         List,
         Edit,
         Create,
         SimpleForm,
         DatagridConfigurable,
         TextField,
         TextInput,
         ReferenceInput,
         ReferenceField,
         AutocompleteInput,
         required } from 'react-admin';
import { stripedDataGridSx } from './styles/dataGridStyles';
import Empty from './components/Empty';
import PlaceIcon from '@mui/icons-material/Place';

const DeliveryLocationFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

const DeliveryLocationPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const DeliveryLocationList = props => {
    return (
        <List
            title="Delivery Locations"
            sort={{ field: 'Delivery_Location', order: 'ASC' }}
            perPage={100}
            pagination={<DeliveryLocationPagination />}
            filters={<DeliveryLocationFilter />}
            bulkActionButtons={false}
            empty={<Empty icon={PlaceIcon} title="No delivery locations yet" description="Add your first delivery location to get started" />}
            {...props}
        >
            <DatagridConfigurable
                rowClick="edit"
                sx={stripedDataGridSx}
            >
                <ReferenceField label="Customer" source="CustomerID" reference="customers">
                    <TextField source="Customer" />
                </ReferenceField>
                <TextField label="Delivery Location" source="Delivery_Location" />
                <TextField label="Street Address" source="Street_Address" />
                <TextField label="City" source="City" />
                <TextField label="State" source="State" />
                <TextField label="Zip" source="Zip" />
                <TextField label="Contacts" source="Contacts" />
                <TextField label="Phone" source="Phone" />
                <TextField label="Contact2" source="Contact2" />
                <TextField label="Phone2" source="Phone2" />
                <TextField label="Delivery Hours" source="Delivery_Hours" />
            </DatagridConfigurable>
        </List>
    )
}

export const DeliveryLocationEdit = props => (
    <Edit undoable={false} {...props}>
        <SimpleForm>
            <ReferenceInput
                label="Customer"
                source="CustomerID"
                sort={{ field: 'Customer', order: 'ASC' }}
                reference="customers" validate={[required()]}>
                <AutocompleteInput label="Customer" optionText="Customer" />
            </ReferenceInput>
            <TextInput disabled label="ID" source="id" />
            <TextInput label="Delivery Location" source="Delivery_Location" />
            <TextInput label="Street Address" source="Street_Address" />
            <TextInput label="City" source="City" />
            <TextInput label="State" source="State" />
            <TextInput label="Zip" source="Zip" />
            <TextInput label="Contacts" source="Contacts" />
            <TextInput label="Phone" source="Phone" />
            <TextInput label="Contact 2" source="Contact2" />
            <TextInput label="Phone 2" source="Phone2" />
            <TextInput label="Delivery Hours" source="Delivery_Hours" />
        </SimpleForm>
    </Edit>
);

export const DeliveryLocationCreate = props => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <ReferenceInput
                label="Customer"
                source="CustomerID"
                reference="customers"
                sort={{ field: 'Customer', order: 'ASC' }}
                validate={[required()]}>
                <AutocompleteInput label="Customer" optionText="Customer" />
            </ReferenceInput>
            <TextInput label="Delivery Location" source="Delivery_Location" />
            <TextInput label="Street Address" source="Street_Address" />
            <TextInput label="City" source="City" />
            <TextInput label="State" source="State" />
            <TextInput label="Zip" source="Zip" />
            <TextInput label="Contacts" source="Contacts" />
            <TextInput label="Phone" source="Phone" />
            <TextInput label="Contact 2" source="Contact2" />
            <TextInput label="Phone 2" source="Phone2" />
            <TextInput label="Delivery Hours" source="Delivery_Hours" />
        </SimpleForm>
    </Create>
);
